module.exports = __webpack_public_path__ + "img/img-icon.8eaef6ce.svg";